import SEOLandingTemplate from './SEOLandingTemplate';

export default function WordCounterPage() {
  return (
    <SEOLandingTemplate
      title="Word Counter"
      metaTitle="Free Word Counter | Sungresh"
      metaDescription="Count words, characters, and sentences, and estimate reading time for any text."
      h1="Free Word Counter"
      sub="Count words, characters, and sentences, and get an estimated reading time — useful for checking content length before you publish."
      keywords="word counter, free word counter, count words, character counter"
      ctaLink="/checker"
      ctaText="Count Words Free"
      features={[
        { icon: '🔢', title: 'Word Count', desc: 'Real-time word count as you type' },
        { icon: '🔤', title: 'Character Count', desc: 'With and without spaces' },
        { icon: '📝', title: 'Sentence Count', desc: 'Sentence count and average sentence length' },
        { icon: '⏱️', title: 'Reading Time', desc: 'Estimated time to read the content' },
      ]}
      faqs={[
        { q: 'Is there an ideal word count for SEO?', a: 'It depends heavily on the topic and search intent — a quick how-to answer might do fine at a few hundred words, while a comprehensive guide competing for a broad topic often benefits from more depth. There\'s no universal target number that guarantees ranking; comprehensiveness matters more than hitting a specific count.' },
        { q: 'Does longer content really rank better?', a: 'Longer content sometimes correlates with better rankings, but that\'s usually because thorough content naturally covers a topic more completely and attracts more links — not because word count itself is a ranking factor. Padding content to hit a number without adding real value tends not to help.' },
      ]}
    />
  );
}
